/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * A sparse serializer representing all possible ProgramItems: [DeploymentProgramItem, ScoreCardSetProgramItem].
 */
export type ProgramItemRequest = {
  /**
   * * `scorecardset` - scorecardset
   * * `project` - project
   */
  item_type: ProgramItemRequest.item_type
  scorecard_set?: string
  project?: string
  weight: string | number
}
export namespace ProgramItemRequest {
  /**
   * * `scorecardset` - scorecardset
   * * `project` - project
   */
  export enum item_type {
    SCORECARDSET = "scorecardset",
    PROJECT = "project",
  }
}
